const initialState = {
  shouldShow: false,
  notStarted: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_NOTIFICATION_BAR':
      return {
        ...state,
        shouldShow: true,
        notStarted: action.notStarted,
      };
    case 'HIDE_NOTIFICATION_BAR':
      return {
        ...state,
        shouldShow: false,
        notStarted: [],
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/NotificationBar/reducer.js